var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"remodal error-remodal",attrs:{"tabindex":"-1","data-remodal-id":"error-modal","data-remodal-options":"hashTracking: false"}},[_c('div',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }